const queries: any = {
  ranking_indicate: [
    {
      $unwind: "$concorrentes_info",
    },
    {
      $group: {
        _id: {
          id_realizacao: "$id_realizacao",
          registration: "$concorrentes_info.registration",
          player: "$concorrentes_info.player",
          name: "$concorrentes_info.name",
        },
        total: {
          $sum: 1,
        },
      },
    },
    {
      $group: {
        _id: "$_id.id_realizacao",
        concorrentes_info: {
          $push: {
            registration: "$_id.registration",
            player: "$_id.player",
            name: "$_id.name",
            total: "$total",
          },
        },
      },
    },
    {
      $lookup: {
        from: "bb_task__c",
        localField: "_id",
        foreignField: "_id",
        as: "task",
      },
    },
    {
      $unwind: "$task",
    },
    {
      $addFields: {
        concorrentes_info: {
          $function: {
            body: "function(arr) { return arr.sort((a, b) => b.total - a.total); }",
            args: ["$concorrentes_info"],
            lang: "js",
          },
        },
      },
    },
    {
      $addFields: {
        concorrentes_info: {
          $slice: ["$concorrentes_info", 5],
        },
      },
    },
    {
      $project: {
        _id: 0,
        id_realizacao: "$_id",
        title: "$task.title",
        category: "$task.category",
        concorrentes_info: 1,
      },
    },
  ],
  evaluated_on_step_3: [
    { $match: { step: 3 } },
    { $unwind: { path: "$realizations" } },
    {
      $lookup: {
        from: "player_fields__c",
        localField: "rawPlayer",
        foreignField: "chave",
        as: "p",
      },
    },
    { $unwind: { path: "$p" } },
    {
      $lookup: {
        from: "indicated_list__c",
        localField: "realizations._id",
        foreignField: "id_realizacao",
        as: "indicados_list",
      },
    },
    {
      $unwind: {
        path: "$indicados_list",
        preserveNullAndEmptyArrays: true,
      },
    },
    {
      $project: {
        _id: 0,
        id_avaliacao: "$_id",
        id_realizacao: "$realizations._id",
        title: "$realizations.title",
        categoria: "$realizations.categoria",
        dt_aceite: "$realizations.dt_aceite",
        description: "$realizations.description",
        documento: "$realizations.documento",
        id_vp: "$p.chave",
        name_vp: "$p.nome",
        prefixo_diretoria: "$p.pref_diretoria",
        totalPontos: "$realizations.totalPontos",
        name_dependency: "$realizations.name_dependency",
        owner: "$realizations.owner",
        owner_name: "$realizations.owner_name",
        team: "$realizations.team",
        indicados: "$indicados_list.indicados",
      },
    },
    {
      $group: {
        _id: "$id_realizacao",
        id_avaliacao: { $first: "$id_avaliacao" },
        id_realizacao: { $first: "$id_realizacao" },
        title: { $first: "$title" },
        categoria: { $first: "$categoria" },
        dt_aceite: { $first: "$dt_aceite" },
        description: { $first: "$description" },
        documento: { $first: "$documento" },
        id_vp: { $first: "$id_vp" },
        name_vp: { $first: "$name_vp" },
        prefixo_diretoria: { $first: "$prefixo_diretoria" },
        totalPontos: { $first: "$totalPontos" },
        name_dependency: { $first: "$name_dependency" },
        owner: { $first: "$owner" },
        owner_name: { $first: "$owner_name" },
        team: { $first: "$team" },
        indicados: { $first: "$indicados" },
        votos: { $sum: 1 },
      },
    },
    { $sort: { categoria: 1, votos: -1 } },
    {
      $group: {
        _id: "$categoria",
        top_realizacoes: {
          $push: {
            id_avaliacao: "$id_avaliacao",
            id_realizacao: "$id_realizacao",
            title: "$title",
            categoria: "$categoria",
            dt_aceite: "$dt_aceite",
            description: "$description",
            documento: "$documento",
            id_vp: "$id_vp",
            name_vp: "$name_vp",
            prefixo_diretoria: "$prefixo_diretoria",
            totalPontos: "$totalPontos",
            name_dependency: "$name_dependency",
            owner: "$owner",
            owner_name: "$owner_name",
            team: "$team",
            indicados: "$indicados",
            votos: "$votos",
          },
        },
      },
    },
    {
      $project: {
        top_realizacoes: { $slice: ["$top_realizacoes", 3] },
      },
    },
    { $unwind: "$top_realizacoes" },
    { $replaceRoot: { newRoot: "$top_realizacoes" } },
  ],
  result_final: [
    {
      $lookup: {
        from: "bb_task__c",
        localField: "id_realizacao",
        foreignField: "_id",
        as: "realizations",
      },
    },
    {
      $unwind: "$realizations",
    },
    {
      $lookup: {
        from: "indicated_list__c",
        localField: "realizations._id",
        foreignField: "id_realizacao",
        as: "indicados_list",
      },
    },
    {
      $unwind: {
        path: "$indicados_list",
        preserveNullAndEmptyArrays: true,
      },
    },
    {
      $project: {
        _id: 0,
        categoria: "$categoria",
        position: "$position",
        votos_popular: "$votos_popular",
        votos_vp: "$votos_vp",
        id_realizacao: "$id_realizacao",
        title: "$realizations.title",
        dt_aceite: "$dt_aceite",
        description: "$realizations.description",
        documento: "$documento",
        prefixo_diretoria: "$p.pref_diretoria",
        totalPontos: "$realizations.totalPontos",
        name_dependency: "$realizations.name_dependency",
        owner: "$realizations.owner",
        owner_name: "$owner_name",
        team: "$realizations.team",
        indicados: "$indicados_list.indicados",
      },
    },
  ],
};

export default queries;
